<template>
  <div>
    <div>
      <el-upload class="upload-image"
                 action=""
                 :disabled="disabled"
                 :before-upload="onFile"
                 multiple>
        <el-button size="small"
                   :disabled="disabled"
                   type="primary">
          {{(v.fileid || '').split('/')[0] === 'tmp' ? 'New file: ' : '' }}
          {{v.filename ? v.filename : '上传图片(支持jpg/png，不超过200k)'}}
        </el-button>
      </el-upload>
    </div>
    <div>
      <el-image style="width: 150px; height: 150px"
                v-if="!!imgurl"
                fit="contain"
                :src="imgurl"></el-image>
    </div>
  </div>
</template>

<script>
import LibProductItem from '../../../minxin/ProductItem';
import base64 from 'base64-arraybuffer'
import request from '../../../api/request';

export default {
  name: 'ProductItemTypeImage',
  mixins: [LibProductItem],
  props: {
    value: Object
  },
  data() {
    return {
    }
  },
  computed: {
    v() {
      return this.dd || {}
    },
    imgurl() {
      if (this.value && this.value.fileid) {
        return request.product.baseURL + '/file.php?file=' + this.value.fileid
      }
      return null
    }
  },
  updated() {
  },
  methods: {
    isJPG(data) {
      return data[0] === 0xff && data[1] === 0xd8 && data[2] === 0xff
    },
    isPNG(data) {
      return data[0] === 0x89 && data[1] === 0x50 && data[2] === 0x4e &&
        data[3] === 0x47 && data[4] === 0x0d && data[5] === 0x0a
    },
    mineType(data) {
      if (this.isJPG(data)) {
        return 'image/jpeg'
      } else if (this.isPNG(data)) {
        return 'image/png'
      }
      return ''
    },
    onFile(file) {
      let filename = file.name
      let ext = filename.split('.')
      if (!['jpg', 'png'].includes(ext[ext.length - 1].toLowerCase())) {
        this.$message.error('只支持jpg或者png格式的图片1')
        return false
      }

      let reader = new FileReader()
      reader.onloadend = function (evt) {
        if (evt.target.readyState === FileReader.DONE) {
          let type = this.mineType(new Uint8Array(evt.target.result))
          if (type === '') {
            this.$message.error('只支持jpg或者png格式的图片2');
            return false
          }

          if (evt.target.result.byteLength > 200 * 1024) {
            this.$message.error('图片大小不能超过200k');
            return false
          }

          request.product.post('file_upload', {
            filename: filename,
            content: base64.encode(evt.target.result),
            mine_type: type
          }).then(r => {
            this.dd = {
              filename: filename,
              fileid: r.data.fileid
            }
          }).catch(() => {
            this.$message.error('upload failed');
          })
        }
      }.bind(this)
      reader.readAsArrayBuffer(file, 'utf-8')
      return false
    }
  }
}
</script>